/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Inbound_Col_Qty_DeclaredInputs */

const en_inbound_col_qty_declared = /** @type {(inputs: Inbound_Col_Qty_DeclaredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Declared`)
};

/**
* | output |
* | --- |
* | "Declared" |
*
* @param {Inbound_Col_Qty_DeclaredInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const inbound_col_qty_declared = /** @type {((inputs?: Inbound_Col_Qty_DeclaredInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Inbound_Col_Qty_DeclaredInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_inbound_col_qty_declared(inputs)
});